import React, { Component } from 'react'
// import Navbar from './components/Navbar.js'
// import Heading from './components/Heading.js'
// import Newslist from './components/Newslist.js'
import Container from './components/Container.jsx'
export default class App extends Component {
  
  render() {
    return (
      <div>
        <Container />
      </div>
    )
  }
}
